import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { JobSummary } from '@interfaces/jobs.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { SeoUrl } from '@pipes/seo-url.pipe';

@Component({
    selector: 'app-job',
    templateUrl: './job.component.html',
    styleUrls: ['./job.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe, SeoUrl]
})
export class JobComponent {
  @Input() job!: JobSummary;
}
